export default __webpack_public_path__ + "static/paskibraka-9233ee5f017a2edb2e0a0d93b3d9eba7.jpg";